import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import Layout from "../../Shared/Layout";
import { SelfGuideCard } from "../../Shared/SelfGuideCard";
import SelfRepairGuidesLayout from "./SelfRepairGuidesLayout";
import { MenuItem } from "@mui/material";
import { useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import i18n from "../../utils/i18n";
import { Trans } from "../../utils/i18n";

export default function SelfRepairGuidesCategoryPage({
    categories,
    category: selectedCategory,
}) {
    return (
        <SelfRepairGuidesLayout
            title={selectedCategory?.description}
            showBackButton={true}
            backButtonUrl={route("selfrepair.guides.index")}
            backgroundImageUrl={selectedCategory?.banner_image}
            searchPlaceholder={i18n.t("selfRepair.searchWithinCategory")}
            searchProductCategoryId={selectedCategory?.id}
        >
            {selectedCategory?.selfRepairFlows?.length === 0 ? (
                <div className="flex flex-col justify-center items-center mx-auto max-w-screen-md w-full gap-y-2">
                    <div className="flex justify-center items-center p-4 rounded-full border border-gray-300">
                        <ArticleOutlinedIcon />
                    </div>

                    <p className="leading-normal text-center text-lg my-0 font-semibold">
                        <Trans i18nKey="selfRepair.category.noGuides">
                            Unfortunately there are no Self-Fix Guides available yet for this product category.
                        </Trans>
                    </p>

                    <p className="leading-normal text-center text-base my-0">
                        <Trans i18nKey="selfRepair.category.noGuides.description">
                            We are working on expanding our knowledge base to be able to help you better in the future. In the meantime, our experts are happy to support you with the repair in our service centers.
                        </Trans>
                    </p>
                </div>
            ) : (
                <div className="flex justify-center w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
                        {selectedCategory?.selfRepairFlows?.map((guide) => (
                            <InertiaLink
                                key={guide.id}
                                className="no-underline"
                                href={route(
                                    "selfrepair.guides.showSelfRepairFlow",
                                    {
                                        category: selectedCategory.slug,
                                        selfrepairflow: guide.slug,
                                    }
                                )}
                            >
                                <SelfGuideCard
                                    name={guide.name}
                                    image={guide.image}
                                    time={guide.time}
                                    complexity={guide.complexity}
                                    targetUser={guide.target_user}
                                />
                            </InertiaLink>
                        ))}
                    </div>
                </div>
            )}
        </SelfRepairGuidesLayout>
    );
}

SelfRepairGuidesCategoryPage.layout = (page) => (
    <Layout children={page} wrapperStyle={{ paddingTop: 0 }} />
);
